import { render } from "./B2bPageEstadisticasEmpresas.vue?vue&type=template&id=c0fab9fc&scoped=true&lang=pug"
import script from "./B2bPageEstadisticasEmpresas.vue?vue&type=script&lang=js"
export * from "./B2bPageEstadisticasEmpresas.vue?vue&type=script&lang=js"

import "./B2bPageEstadisticasEmpresas.vue?vue&type=style&index=0&id=c0fab9fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fab9fc"]])

export default __exports__